module.exports = __webpack_public_path__ + "media/images/menu/auriga-15e1e19abffbdf8c13c12f25ea7d4579.jpg";